<div class="cards">
	<div *ngFor="let card of player.XP; let num = index" (click)="selectCard(num)" [ngClass]="{'selected': selected[num]}" hotmCardRatio>{{ card.level }}<span *ngIf="card.cardType === cardType.blank">(bonus)</span></div>
</div>
<div class="actions">
	<h1>Select card(s) to trade in for XP</h1>
	<p *ngIf="selectedTotal === 0"><button (click)="doneXP.emit()">Cancel</button></p>
	<h1 *ngIf="selectedTotal">{{ selectedTotal }} point<span *ngIf="selectedTotal !== 1">s</span> selected, {{ selectedTotal - currTotal }} used</h1>
	<p *ngIf="selectedTotal"><button (click)="doneXP.emit()">Cancel</button> <button [disabled]="selectedTotal === currTotal" (click)="confirm()">Confirm</button></p>
</div>
<div class="attributes">
	<dl>
		<dt>
			<button [disabled]="tempAttributes.Brains === player.nativeStats.Brains" (click)="decrement('Brains')">−</button>
			{{ tempAttributes.Brains }}
			<button [disabled]="(currTotal < tempAttributes.Brains) && (minOnly ? player.nativeStats.Brains <= player.nativeStats.Brawn && player.nativeStats.Brains <= player.nativeStats.Bravado : true)" (click)="increment('Brains')">+</button>
		</dt>
		<dd>Brains</dd><dd>{{ itemDisplay.Brains }}</dd>
		<dt>
			<button [disabled]="tempAttributes.Brawn === player.nativeStats.Brawn" (click)="decrement('Brawn')">−</button>
			{{ tempAttributes.Brawn }}
			<button [disabled]="(currTotal < tempAttributes.Brawn) && (minOnly ? player.nativeStats.Brawn <= player.nativeStats.Brains && player.nativeStats.Brawn <= player.nativeStats.Bravado : true)" (click)="increment('Brawn')">+</button>
		</dt>
		<dd>Brawn</dd><dd>{{ itemDisplay.Brawn }}</dd>
		<dt>
			<button [disabled]="tempAttributes.Bravado === player.nativeStats.Bravado" (click)="decrement('Bravado')">−</button>
			{{ tempAttributes.Bravado }}
			<button [disabled]="(currTotal < tempAttributes.Bravado) && (minOnly ? player.nativeStats.Bravado <= player.nativeStats.Brains && player.nativeStats.Bravado <= player.nativeStats.Brawn : true)" (click)="increment('Bravado')">+</button>
		</dt>
		<dd>Bravado</dd><dd>{{ itemDisplay.Bravado }}</dd>
	</dl>
</div>
